const severityStyles: Record<string, string> = {
  critical: 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300',
  warning: 'bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300',
  informational: 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300',
  info: 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300',
  good: 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300',
};

export default function GMBSeverityBadge({ severity }: { severity: string }) {
  const normalized = (severity || 'info').toLowerCase();
  const styles = severityStyles[normalized] || severityStyles.info;
  const label = severity.charAt(0).toUpperCase() + severity.slice(1);
  return (
    <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium whitespace-nowrap ${styles}`}>
      {label}
    </span>
  );
}